import React from 'react';
import DialogActions from './DialogActions';
import { useMobileBreakpoint } from '../../utils';
import { Box } from '../Layout';
/**
 * A convenience component that renders 1-3 Buttons, with a common responsive layout pattern.
 * Is to be used instead of `DialogActions`.
 * @param children 1-3 ReactElements.
 */
var DialogCommonActions = function (_a) {
    var children = _a.children;
    var isMobile = useMobileBreakpoint();
    var childrenArray = React.Children.toArray(children);
    if (childrenArray.length < 1 || childrenArray.length > 3) {
        console.error('DialogCommonActions accepts 1 to 3 children only. Rendering <DialogActions> as a fallback.');
        return React.createElement(DialogActions, { direction: "row-reverse" }, children);
    }
    return (React.createElement(DialogActions, { direction: isMobile ? 'column' : 'row-reverse', justifyContent: "flex-start", alignItems: isMobile ? undefined : 'end' },
        childrenArray[0],
        childrenArray[1],
        childrenArray[2] ? (React.createElement(Box, { sx: {
                flexGrow: { sm: 0, md: 1 },
                marginLeft: { md: '-8px !important' },
                display: 'flex',
                '& > :first-of-type': { flexGrow: isMobile ? 1 : 0 },
                // using `last-of-type` to increase specificity to override `MuiStack-root>:not(style)~:not(style)`
                '&:last-of-type': { marginTop: { sm: '6px', md: 0 } },
            } }, childrenArray[2])) : null));
};
export default DialogCommonActions;
//# sourceMappingURL=DialogCommonActions.js.map